angular.module('ikeweb.spike.measure').service('selectedMeasurementService', ['pubSubService', 'measureTopics', 'validationService',

    function(pubSubService, measureTopics, validation) {

        var validators = validation.validators,
            aString = validators.aString,
            empty = validators.empty,
            aNumber = validators.aNumber;
        var measurement;

        function setMeasurement(value) {
            return validation
                .validate(value.getId()).is(aString).is.not(empty)
                .validate(value.getName()).is(aString).is.not(empty)
                .validate(value.getArea()).is(aNumber)
                .validate(value.getPerimeter()).is(aNumber)
                .check()
                .then(function() {
                    measurement = value;
                    pubSubService.publish(measureTopics.MEASUREMENT.SELECTED);
                });
        }

        function getMeasurement() {
            return measurement;
        }

        function reset() {
            measurement = undefined;
        }

        return {
            getMeasurement: getMeasurement,
            setMeasurement: setMeasurement,
            reset: reset
        };
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/spike/measure/measurements-detail/selected.measurement.service.js
// module id = 575
// module chunks = 0